export const environment = {
  production: false,
  //url_api : 'http://localhost:52000/api/',
  //url_api_seguridad : 'http://localhost:52000/api/',
  url_api : 'https://sbaperu2020-002-site1.anytempurl.com/api/',
  url_api_seguridad : 'https://sbaperu2020-002-site1.anytempurl.com/api/',
  estacion: 'Web-ESAN'
};